<template lang="pug">
    .container.content(:class="{ 'has-text-centered': textAlignment === 'center' }")
        .column.is-offset-1.is-10(v-if="edit")
            .field(v-if="subHeading !== null && subHeading !== undefined")
                validation-provider(
                    ref="subHeading"
                    :vid="subHeadingVid"
                    :name="subHeadingFieldName"
                    :rules="subHeadingRules"
                    v-slot="{ errors }"
                )
                    label.label(v-if="labels.subTitle" v-html="labels.subTitle")
                    input.heading(
                        v-model="subHeading"
                        :class="[ classes.subHeading, { 'is-danger': errors && errors.length }]"
                        contenteditable="edit"
                    )
                    //- component(
                    //-     contenteditable="edit"
                    //-     :placeholder="placeholders.subTitle"
                    //-     :is="subHeadingTag"
                    //-     :class="classes.subHeading"
                    //-     @input="updateSubHeading($event.target.innerText)"
                    //-     ref="subTitle"
                    //- )
                    p.help.is-danger.has-text-left(v-if="errors && errors.length") {{ errors[0] }}
                    p.help.has-text-grey.has-text-left(v-else) Pflicht
            .field(v-if="heading !== null && heading !== undefined")
                validation-provider(
                    ref="heading"
                    :vid="headingVid"
                    :name="headingFieldName"
                    :rules="headingRules"
                    v-slot="{ errors }"
                )
                    label.label(v-if="labels.title" v-html="labels.title")
                    input.heading(
                        v-model="heading"
                        :class="[ classes.heading, { 'is-danger': errors && errors.length }]"
                        contenteditable="edit"
                    )
                    //- component(
                    //-     contenteditable="edit"
                    //-     :placeholder="placeholders.title"
                    //-     :is="headingTag"
                    //-     :class="classes.heading"
                    //-     @input="updateHeading($event.target.innerText)"
                    //-     ref="title"
                    //- )
                    p.help.is-danger.has-text-left(v-if="errors && errors.length") {{ errors[0] }}
                    p.help.has-text-grey.has-text-left(v-else) Pflicht
        .column.is-offset-1.is-10(v-else)
            component.has-no-margin(v-if="subHeading" :is="subHeadingTag" :class="classes.subHeading") {{ subHeading }}
            component.has-no-margin(v-if="heading" :is="headingTag" :class="classes.heading") {{ heading }}
</template>

<script>

import _ from 'lodash'
import { ValidationProvider } from 'vee-validate'

export default {
    name: 'Heading',
    props: {
        headingVid: {
            type: String,
        },
        headingFieldName: {
            type: String,
            default: '',
        },
        headingRules: {
            type: [Object, String],
            default: "",
        },

        subHeadingVid: {
            type: String,
        },
        subHeadingFieldName: {
            type: String,
            default: '',
        },
        subHeadingRules: {
            type: [Object, String],
            default: "",
        },

        edit: {
            type: Boolean,
            default: false,
        },
        section: {
            type: Object,
            required: true,
        },
        headingTag: {
            type: String,
            default: 'h2',
        },
        headingClass: {
            type: String,
            default: 'is-size-1-desktop is-size-2-tablet is-size-3-mobile has-text-weight-light',
        },
        subHeadingTag: {
            type: String,
            default: 'h3',
        },
        subHeadingClass: {
            type: String,
            default: 'is-size-5-desktop is-size-6-touch is-uppercase has-text-primary',
        },
    },
    components: {
        ValidationProvider,
    },
    computed: {
        heading: {
            get() {
                return _.get(this.section, 'contents.0.title');
            },
            set(value) {
                this.$emit('change', this.section.id, this.section.contents[0].id, 'title', value)
                if (this.$refs.heading.mode === 'aggressive' || this.$refs.heading.mode === 'lazy') {
                    this.$refs.heading.validate();
                }
            }
        },
        subHeading: {
            get() {
                return _.get(this.section, 'contents.0.sub_title');
            },
            set(value) {
                this.$emit('change', this.section.id, this.section.contents[0].id, 'sub_title', value)
                if (this.$refs.subHeading.mode === 'aggressive' || this.$refs.subHeading.mode === 'lazy') {
                    this.$refs.subHeading.validate();
                }
            }
        },
        labels() {
            let labels = {
                title: _.get(this.section, 'contents.0.labels.title'),
                subTitle: _.get(this.section, 'contents.0.labels.sub_title'),
            }

            return labels
        },
        placeholders() {
            let placeholders = {
                title: _.get(this.section, 'contents.0.placeholders.title'),
                subTitle: _.get(this.section, 'contents.0.placeholders.sub_title'),
            }

            return placeholders
        },
        textAlignment() {
            let alignment = 'center'

            if (this.section.settings && this.section.settings.length) {
                const setting = this.section.settings.find(setting => setting.key === 'text_alignment')
                if (setting && setting.value !== undefined) alignment = setting.value
            }

            return alignment
        },
        classes() {
            let classes = {
                heading: this.headingClass,
                subHeading: this.subHeadingClass,
            }

            const settings = _.get(this.section.contents[0], 'settings') || []
            const titleSize = settings.find(setting => setting.key === 'title_size')
            const subTitleSize = settings.find(setting => setting.key === 'sub_title_size')

            if (titleSize && titleSize.value !== undefined) {
                switch (titleSize.value) {
                    case 'large':
                        classes.heading = 'is-size-1-desktop is-size-2-tablet is-size-3-mobile has-text-weight-light'
                        break;

                    case 'small':
                        classes.heading = 'is-size-4-desktop is-size-5-tablet is-size-6-mobile has-text-weight-light'
                        break;

                    case 'regular':
                    default:
                        classes.heading = 'is-size-2-desktop is-size-3-tablet is-size-4-mobile has-text-weight-light'
                }
            }

            if (subTitleSize && subTitleSize.value !== undefined) {
                switch (subTitleSize.value) {
                    case 'large':
                        classes.subHeading = 'is-size-5-desktop is-size-6-touch is-uppercase has-text-primary'
                        break;

                    case 'small':
                        classes.subHeading = 'is-size-7-desktop is-size-7-touch is-uppercase has-text-primary'
                        break;

                    case 'regular':
                    default:
                        classes.subHeading = 'is-size-6-desktop is-size-7-touch is-uppercase has-text-primary'
                }
            }

            return classes
        }
    },
    // methods: {
    //     updateHeading(value) {
    //         this.$emit('change', this.section.id, this.section.contents[0].id, 'title', value)
    //         if (this.$refs.heading.mode === 'aggressive' || this.$refs.heading.mode === 'lazy') {
    //             this.$refs.heading.validate();
    //         }
    //     },
    //     updateSubHeading(value) {
    //         this.$emit('change', this.section.id, this.section.contents[0].id, 'sub_title', value)
    //         if (this.$refs.subHeading.mode === 'aggressive' || this.$refs.subHeading.mode === 'lazy') {
    //             this.$refs.subHeading.validate();
    //         }
    //     }
    // },
    // mounted() {
    //     if (this.$refs.title && this.heading) this.$refs.title.innerText = this.heading
    //     if (this.$refs.subTitle && this.subHeading) this.$refs.subTitle.innerText = this.subHeading
    // }
}
</script>

<style lang="sass" scoped>

    // @import "~bulma/sass/utilities/mixins";

    .container.content .column
        *
            text-transform: initial
        .field + .field
            margin-top: 20px
        .has-no-margin
            margin: 0
    label
        text-align: left
        // & + *
        //     margin-top: 0

    [contentEditable=true]
        text-align: left

    input
        display: block
        width: 100%

</style>
